import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import MultiLines from './MultiLines';
import useStyles from './Styles';

interface Props {
    mes: string,
    yes():void,
    no():void,
    isOpen:boolean,
	labels?:string[],
	danger?:boolean,
}

const Yesno = (props:Props)=> {
    const classes = useStyles();

	const labels:string[] = ['はい','いいえ'];
	if( props.labels ){
		labels[0] = props.labels[0];
		labels[1] = props.labels[1];
	}

	const danger = props.danger!==null && props.danger===true

    return (
		<Dialog
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={false}
			onClose={props.no}
		>
			<DialogContent>
				<MultiLines text={props.mes}/>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button variant="text" color="primary" onClick={props.no}>{labels[1]}</Button>
				<Button variant="contained" color={danger ? 'secondary' : 'primary'} onClick={props.yes}>{labels[0]}</Button>
			</DialogActions>
        </Dialog>
    );
}

export default Yesno;
